import PropTypes from "prop-types";
import React from "react";
import classNames from "classnames";
import getClassNameFactory from "../../utilities/classNames";

var MarkupContainer = function MarkupContainer(_ref) {
  var children = _ref.children,
      sticky = _ref.sticky;
  var getClassName = getClassNameFactory(MarkupContainer.displayName);
  return /*#__PURE__*/React.createElement("div", {
    "data-react-from-markup-container": true,
    className: getClassName({
      modifiers: classNames({
        sticky: sticky
      })
    })
  }, children);
};

MarkupContainer.displayName = "MarkupContainer";
MarkupContainer.propTypes = {
  /**
   * Children
   */
  children: PropTypes.node.isRequired,

  /**
   * Enable wrapping of `position: sticky` rehydratable components
   */
  sticky: PropTypes.bool
};
export default MarkupContainer;